import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ec5ba45")

_pushScopeId("data-v-6ec5ba45")
const _hoisted_1 = { class: "tracking" }
const _hoisted_2 = /*#__PURE__*/_createVNode("section", { id: "tracking-map" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_courier_information = _resolveComponent("courier-information")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_courier_information, {
      courier: _ctx.state.courier,
      "address-from": _ctx.state.address_from,
      "address-to": _ctx.state.address_to,
      "is-loading": _ctx.state.is_loading,
      "is-failed": _ctx.state.is_failed,
      "is-loaded": _ctx.state.is_loaded,
      "is-delivery-completed": _ctx.state.is_delivery_finished
    }, null, 8, ["courier", "address-from", "address-to", "is-loading", "is-failed", "is-loaded", "is-delivery-completed"])
  ]))
})